import "../styles/landingpage.css";
import { useNavigate } from "react-router-dom";
import tagManagerEvents from "../utils/GoogleTagManager";
interface Props {
  jc: string;
  utmSource: string;
}
const LandingResponse = (props: Props) => {
  console.log("props::", props);
  const jc = props?.jc;
  const utmSource = props?.utmSource;
  if (jc === "1") {
    tagManagerEvents("Success_Popup", utmSource);
  }
  const navigate = useNavigate();
  return (
    <>
      <div className="">
        <div className="dm-section landing_res">
          <div className="main-content">
            <img
              src="https://cdn.econceptionscdn.com/Tamasha/imgs/main-img-slanding.webp"
              alt="sports"
              width={345}
              height={333}
              className="sucess-main-image"
            />

            {jc === "1" ? (
              <div className="cong-box">
                <img
                  src="https://cdn.econceptionscdn.com/Tamasha/imgs/landing-check-img.webp"
                  alt="landing-check-img"
                  width={40}
                  height={40}
                />
                <div className="mubarakhead">Mubarak Ho!</div>
                <div className="mubaraltext">
                  Aap Kamyabi k sath Tamasha Family Ka hisa ban chukay hain,
                  <br /> Abhi Tamasha app download karein!
                </div>
                <div className="tamashastore">
                  <a href="http://onelink.to/brxfjq" target="_blank">
                    <img
                      src="https://cdn.econceptionscdn.com/Tamasha/imgs/appstore.webp"
                      alt="app store"
                    />
                  </a>
                  <a href="http://onelink.to/brxfjq" target="_blank">
                    <img
                      src="https://cdn.econceptionscdn.com/Tamasha/imgs/google_play.webp"
                      alt="google play"
                    />
                  </a>
                </div>
                <a
                  href="http://onelink.to/brxfjq"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                  onClick={() => {
                    tagManagerEvents("DownLoad_Button_Click", utmSource);
                  }}
                >
                  <button className="landing_res_btn">Download Now</button>
                </a>
              </div>
            ) : (
              <div
                className="cong-box" /* {`cong-box ${props.isHidden ? "hidden" : ""}`} */
              >
                <img
                  src="https://cdn.econceptionscdn.com/Tamasha/imgs/landing-emoji-img.webp"
                  alt="landing-emoji-img"
                  width={40}
                  height={40}
                />

                <div className="mubaraltext">
                  Subscription kaamyaab nahi hoi.
                </div>
                {/* <div className="tamashastore">
                                <a href="https://app.tamashaweb.com/JHLA" target="_blank">
                                    <img src={appstore} alt="app store" />
                                </a>
                                <a href="https://app.tamashaweb.com/JHLA" target="_blank">
                                    <img src={google_play} alt="google play" />
                                </a>
                            </div> */}
                <button
                  className="landing_res_btn"
                  onClick={() => navigate("/landingjazzcash")}
                >
                  Try Again
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingResponse;
